/**
 * @flow
 */
'use strict';

export const raisonComplementaireCodes = [
{"code":" 1mois"},
{"code":"1er examen"},
{"code":"2 semaines"},
{"code":"2e avis"},
{"code":"Ajustement V.C"},
{"code":"Autres symptomes 2"},
{"code":"Avec LC"},
{"code":"Avec lunettes"},
{"code":"Avec ordinateur"},
{"code":"Baisse VL ?"},
{"code":"Baisse VP"},
{"code":"Baisse VP ?"},
{"code":"Bris de monture"},
{"code":"Changement vision"},
{"code":"Changer lunette"},
{"code":"Changer lunette ?"},
{"code":"Chgmt VL"},
{"code":"Clignement"},
{"code":"Commande LC"},
{"code":"Constant"},
{"code":"Corps flottant"},
{"code":"Cyclo"},
{"code":"Depistage"},
{"code":"Depistage diabete"},
{"code":"Depuis 1 semaine"},
{"code":"Depuis 3 mois"},
{"code":"Depuis 5 mois"},
{"code":"Diabétique"},
{"code":"Difficulté petits caractères"},
{"code":"Dilatation"},
{"code":"Diplopie"},
{"code":"Douleur"},
{"code":"Essai LC"},
{"code":"Etourdissement"},
{"code":"Examen complet"},
{"code":"Examen complet ?"},
{"code":"Fatigue oculaire"},
{"code":"Flottant"},
{"code":"Form SAAQ"},
{"code":"Formulaire travail"},
{"code":"Forte myopie"},
{"code":"Frontale"},
{"code":"Inconfort"},
{"code":"Intermittent"},
{"code":"Le matin"},
{"code":"Le soir"},
{"code":"Leger"},
{"code":"Lunette VP"},
{"code":"Lunette abimée"},
{"code":"Lunette brisée"},
{"code":"Lunette lecture"},
{"code":"Lunette solaire"},
{"code":"Lunette solaire ?"},
{"code":"Lunette sécurité"},
{"code":"Légère myopie"},
{"code":"Mal oeil"},
{"code":"Matin"},
{"code":"Mdet"},
{"code":"Medecin"},
{"code":"Monture petite"},
{"code":"Nouvelle lunette"},
{"code":"O.D."},
{"code":"O.G."},
{"code":"O.G.stt"},
{"code":"O.U."},
{"code":"OD stt"},
{"code":"OD surtt."},
{"code":"Ordinateur"},
{"code":"Orgelet"},
{"code":"Parfois VL difficile"},
{"code":"Paupiere"},
{"code":"Perdu lunette"},
{"code":"Permis conduire"},
{"code":"Permis conduire ?"},
{"code":"Porteur LC"},
{"code":"Post cat"},
{"code":"Probl.ordi"},
{"code":"Problème LC"},
{"code":"Rapport"},
{"code":"Rapport armée"},
{"code":"Rapport tech.policiere"},
{"code":"Recommandé par rhumatologue"},
{"code":"Reference MD"},
{"code":"Renouveler LUN sécurité"},
{"code":"Restasis"},
{"code":"Retard langage"},
{"code":"Rougeur"},
{"code":"Routine"},
{"code":"Rx sécurité"},
{"code":"Sans Rx"},
{"code":"Semi-rigide"},
{"code":"Suivi"},
{"code":"Suivi urgence"},
{"code":"Sécurité"},
{"code":"Tx cache"},
{"code":"Utilise loupe vp"},
{"code":"V.L. brouillée"},
{"code":"VL diff parfois"},
{"code":"VP diff avec Rx"},
{"code":"VP difficile"},
{"code":"Veut LC"},
{"code":"Veut rx vp"},
{"code":"Vision brouillée"},
{"code":"Vision de loin"},
{"code":"Vision de près"},
{"code":"Vision ok avec Rx"},
{"code":"Vl et vp"},
{"code":"Vérif.LC"},
{"code":"Vérif.santé oculaire"},
]
